import { AnchorHTMLAttributes } from 'react';

export const ExternalLink = ({
  href,
  children,
  style,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ fontFamily: "'DM Sans', sans-serif", color: 'inherit', ...style }}
      {...props}
    >
      {children}
    </a>
  );
};
